<lms-breadcrumb
  [crumbs]="[{ label: 'credits.pageLabels.add', icon: 'glicon-file-survey', route: '.' }]"
></lms-breadcrumb>
<lms-credit-editor (saved)="onSave($event)" [client]="client">
  <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="cancel()" form-actions-before></gl-button>
</lms-credit-editor>
